import type { RowData } from '../../types/RowData';
import { selectPreviousRows } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useGridPreviousRows() {
  return useEagGridSelector(selectPreviousRows);
}